import './marketing-panel.module.scss';
import classes from './marketing-panel.module.scss';
import { Card, CardActions, CardContent, CardMedia } from '@mui/material';
import { CcfBox, CcfTypography, CcfButton, useTranslator } from '@nice-ccf/ui-controls';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/* eslint-disable-next-line */
export interface MarketingPanelProps {}

/**
 * Component used to display marketing panel
 * @param props - MarketingPanelProps
 * @example - <MarketingPanel />
 * @returns
 */
export function MarketingPanel(props: MarketingPanelProps) {
  const [translate] = useTranslator();
  return (
    <CcfBox px={2} className={classes.marketingPanel}>
      <Card elevation={0} className={`${classes.app} heightInherit`}>
        <CardMedia
          image="/assets/branding-image.png"
          className={classes.image}
        />
        <CardContent>
          <CcfTypography variant={'body2'} gutterBottom>
            <CcfBox className={classes.title}>
              {translate('welcomeToAgeOfAI')}
            </CcfBox>
          </CcfTypography>
          <CcfTypography variant={'body2'} gutterBottom>
            <CcfBox className={classes.subTitle}>
              {translate('ourServices')}
            </CcfBox>
          </CcfTypography>
          <CcfTypography variant={'body2'}>
            <CcfBox className={classes.content}>
              {translate('webinarsDescription1')}
              {translate('webinarsDescription2')}
              
            </CcfBox>
          </CcfTypography>
        </CardContent>
        <CardActions className={classes.registerNowButtonBlock}>
          <CcfBox px={1}>
            <CcfButton
              size="large"
              variant="contained"
              classes={{ root: classes.actionButton }}
            >
              <ArrowForwardIcon
                fontSize="small"
                style={{ marginRight: '5px' }}
              />
              {translate('viewWebinars')}
            </CcfButton>
          </CcfBox>
        </CardActions>
      </Card>
    </CcfBox>
  );
}

export default MarketingPanel;
